import * as React from "react"
import ListItemButton from "@mui/material/ListItemButton"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import PeopleIcon from "@mui/icons-material/People"
import { Link } from "react-router-dom"
import { AdminPanelSettings, AnalyticsOutlined, ArrowDropDown, ArrowRight, BusinessOutlined, Campaign, CampaignOutlined, Category, ChecklistRtl, ContactPage, ContactPhone, Dashboard, Description, Done, DynamicFormOutlined, Dvr, ElectricalServices, EventAvailableOutlined, GridView, GroupAdd, HistorySharp, InboxOutlined, ListAlt, PeopleAltTwoTone, Person, PersonPinCircle, PhoneAndroid, PriceChange, RecordVoiceOverOutlined, SchoolOutlined, Settings, SmartToyOutlined, UploadFileSharp, VideoCallOutlined } from "@mui/icons-material"
import { useAppSelector } from "../../../app/hooks"
import { RootState } from "../../../app/store"
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { Menu } from "@mui/material"
import { blue } from "@mui/material/colors"
import { OmegaSoftConstants } from "../../../app/khas-web-constants"
interface RouteItemI {
  to?: string
  Icon: any
  title: string
  children?: RouteItemI[]
  superAdmin?: boolean
  crmAdminOnly?: boolean
}

export function MenuItems({onClick = ()=> {}} : {onClick: () => void}) {
  
  const {currentUser} = useAppSelector((state: RootState) => state.login)
  const mapRoutes: RouteItemI[] = [
    // { to: "/dashboard/create-raffle", Icon: <PeopleIcon />, title: "Agregar Sorteo" },
    // { to: "/dashboard/raffles", Icon: <PeopleIcon />, title: "Sorteos" },
    // { to: "/dashboard/create-card", Icon: <Margin />, title: "Crear Tarjeta" },

    { to: "", Icon: <Dashboard />, title: "Resume" },
    { Icon: <BusinessOutlined />, title: "Projects", children: [
      { to: "/dashboard/projects", Icon: <BusinessOutlined />, title: "Proyectos" },
      { to: "/dashboard/lot-inventory", Icon: <GridView />, title: "Inventario de lotes" },
      { to: "/dashboard/project-releases", Icon: <Done />, title: "Proyectos finalizado" },
    ]},
    { to: "/dashboard/users", Icon: <PeopleIcon />, title: "Usuarios", children: [
      { to: "/dashboard/users", Icon: <PeopleIcon />, title: "Usuarios"},
      { to: "/dashboard/users/profile", Icon: <Person />, title: "Mi perfil" },
      { to: "/dashboard/offices-list", Icon: <BusinessOutlined />, title: "Oficinas" },
      { to: "/dashboard/signed-contracts", Icon: <Description />, title: "Contratos enviados a firma" },
      { to: "/dashboard/signup-campaigns", Icon: <Campaign />, title: "Campañas de registro" },
      { to: "/dashboard/job-campaigns", Icon: <Campaign />, title: "Campañas de reclutamiento", crmAdminOnly: true },
      { to: "/dashboard/audits", Icon: <AdminPanelSettings />, title: "Auditoria" },
    ]},
    { Icon: <ContactPhone />, title: "Leads", children: [
      { to: "/dashboard/leads", Icon: <InboxOutlined />, title: "Bandeja de leads", crmAdminOnly: true },
      { to: "/dashboard/meta-lead-forms", Icon: <DynamicFormOutlined />, title: "Formularios Meta leads", crmAdminOnly: true },
      { to: "/dashboard/lead-conversations", Icon: <SmartToyOutlined />, title: "Conversaciones IA leads", crmAdminOnly: true },
      { to: "/dashboard/lead-call-schedule", Icon: <EventAvailableOutlined />, title: "Agenda llamadas leads", crmAdminOnly: true },
      { to: "/dashboard/webinar", Icon: <VideoCallOutlined />, title: "Webinars / MasterClass", crmAdminOnly: true },
      { to: "/dashboard/ceo-leads-resume", Icon: <CampaignOutlined />, title: "Leads Resume" },
    ]},
    { Icon: <PeopleAltTwoTone />, title: "Clientes", children: [
      { to: "/dashboard/customers-v2", Icon: <PeopleAltTwoTone />, title: "Clientes V2" },
      { to: "/dashboard/customers-v2/import", Icon: <PeopleAltTwoTone />, title: "Importar clientes" },
      { to: "/dashboard/customers-v2/call-logs", Icon: <HistorySharp />, title: "Registro de llamadas" },
      { to: "/dashboard/customers-v2/live-calls", Icon: <RecordVoiceOverOutlined />, title: "Llamadas en vivo", crmAdminOnly: true },
      { to: "/dashboard/customers-v2/events", Icon: <HistorySharp />, title: "Eventos" },
      { to: "/dashboard/customers-v2/assignment-audit", Icon: <HistorySharp />, title: "Historial asignaciones" },
      { to: "/dashboard/steps-v2", Icon: <Category />, title: "Steps V2" },
      { to: "/dashboard/staff-performance", Icon: <AnalyticsOutlined />, title: "Rendimiento personal" },
      { to: "/dashboard/whatsapp-marketing", Icon: <Campaign />, title: "Campañas WhatsApp", crmAdminOnly: true },
    ]},
    { Icon: <GroupAdd />, title: "Referidos", children: [
      { to: "/dashboard/users/referral-follow-up", Icon: <ListAlt />, title: "Seguimiento Referidos" },
      { to: "/dashboard/users-onboarding-status", Icon: <ChecklistRtl />, title: "Onboarding status" },
      { to: "/dashboard/import-users", Icon: <UploadFileSharp />, title: "Importar usuarios" },
      { to: "/dashboard/traninng-traking", Icon: <ChecklistRtl />, title: "Capacitaciones" },
      { to: "/dashboard/referidos/lead-candidates", Icon: <ContactPage />, title: "Candidatos" },
    ]},
    { Icon: <SchoolOutlined />, title: "Entrenamientos", children: [
      { to: "/dashboard/training-sessions", Icon: <VideoCallOutlined />, title: "Sesiones" },
    ]},
    { Icon: <ChecklistRtl />, title: "Auditoria", children: [
      // { to: "/dashboard/leads-auditory", Icon: <ChecklistRtl />, title: "Leads Auditory" },
      { to: "/dashboard/customer-payments-auditory", Icon: <PriceChange />, title: "Pagos Clientes" },
      { to: "/dashboard/customers-v2/call-audit", Icon: <HistorySharp />, title: "Auditoría de llamadas" },
      {
        to: "/dashboard/customers-v2/call-audit-ai",
        Icon: <AdminPanelSettings />,
        title: "Revisión IA llamadas",
        crmAdminOnly: true,
      },
      {
        to: "/dashboard/onboarding-voice-call-audit-ai",
        Icon: <RecordVoiceOverOutlined />,
        title: "Revisión IA voz onboarding",
        crmAdminOnly: true,
      },
      // { to: "/dashboard/steps", Icon: <Category />, title: "Pasos" },
      // { to: "/dashboard/step-logs", Icon: <WebStories />, title: "Historial Pasos" },
      // { to: "/dashboard/user-actives-snap-shot", Icon: <AppsOutage />, title: "Activos historial" },
      // { to: "/dashboard/handle-payment", Icon: <Money />, title: "Admin pago" },
      // { to: "/dashboard/steps-week-stats", Icon: <Money />, title: "Grafica clientes nuevos por semana" },
      // { to: "/dashboard/users-goal-view", Icon: <Done />, title: "Metas usuarios" },
      // { to: "/dashboard/alerted-payments", Icon: <AddAlertTwoTone />, title: "Payments alert" },
      // { to: "/dashboard/check-customers", Icon: <PersonPin />, title: "Validacion clientes" },
    ] },
    
    { to: "/dashboard/settings", Icon: <Settings />, title: "Settings" },
    { to: "/dashboard/events-gateway", Icon: <ElectricalServices />, title: "Socket" },
    { to: "/dashboard/twilio-numbers", Icon: <PhoneAndroid />, title: "Twilio numbers" },
    
    // { to: "/dashboard/face-auth-cam-face", Icon: <Category />, title: "Cam Face recognition" },
    // { to: "/dashboard/face-auth", Icon: <Category />, title: "Face Test" },
    // { to: "/dashboard/capital-contribute", Icon: <AddBusiness />, title: "Aporte Capital" },
    // { to: "/dashboard/closure", Icon: <Analytics />, title: "Cuadre" },
    // { to: "/dashboard/cards-lists", Icon: <List />, title: "Lista" },
    // { to: "/dashboard/externals", Icon: <ThreePIcon />, title: "Externos" },
    
  ]
  
  const mapRoutesAssigner: RouteItemI[] = [
    { to: "/dashboard/users", Icon: <PeopleIcon />, title: "Usuarios" },
    { to: "/dashboard/customers-v2", Icon: <Dvr />, title: "Clientes" },
    { to: "/dashboard/lot-inventory", Icon: <GridView />, title: "Inventario de lotes" },
  ]

  const mapRoutesFinance: RouteItemI[] = []

  const mapRoutesLeader: RouteItemI[] = [
    { to: "/dashboard/users", Icon: <PeopleIcon />, title: "Usuarios" },
    { to: "/dashboard/customers-v2", Icon: <ArrowDropDown />, title: "Clientes" },
  ]

  const mapRoutesUser: RouteItemI[] = [
    { to: "/dashboard/customers-v2", Icon: <ContactPhone />, title: "Clientes" },
  ]
  
  const mapRoutesOffice: RouteItemI[] = [
    { to: "/dashboard/log-arrive", Icon: <PersonPinCircle />, title: "Registro llegada" },
    //{ to: "/dashboard/lea`10\
    // \[';fre4dw32qas3defg.;'/
    // .;,<gfdswaq>` </gfdswaq>d-campaign", Icon: <Campaign />, title: "Campaña" },
  ]
  
  const mapRoutesSecretary: RouteItemI[] = [
    { to: "/dashboard/customers-v2", Icon: <PersonPinCircle />, title: "Clientes" },
  ]
  
  const mapRoutesContent: RouteItemI[] = [
    { Icon: <BusinessOutlined />, title: "Projects", children: [
      { to: "/dashboard/lot-inventory", Icon: <GridView />, title: "Inventario de lotes" },
      { to: "/dashboard/projects", Icon: <BusinessOutlined />, title: "Proyectos" },
      { to: "/dashboard/project-releases", Icon: <Done />, title: "Proyectos finalizado" },
    ]},
  ]

  return (
    <React.Fragment>
        {(currentUser?.level === 0 || currentUser?.level === 1 ? mapRoutes : 
          currentUser?.level === 2 ? mapRoutesAssigner :  
          currentUser?.level === 3 ? mapRoutesLeader : 
          currentUser?.level === 6 ? mapRoutesOffice : 
          currentUser?.level === 7 ? mapRoutesFinance : 
          currentUser?.level === 8 ? mapRoutesSecretary : 
          currentUser?.level === 9 ? mapRoutesContent : 
          mapRoutesUser).map((el, i) => {

          if(el.children!?.length > 0) {
              if(el.superAdmin && !OmegaSoftConstants.superUsersId.includes(currentUser!.email!)) return <React.Fragment key={`menu_item_${i}`}/>
              return (
              <PopupState variant="popover" popupId={`menu_item_${i}`} key={`menu_item_${i}`}>
                {(popupState) => (
                  <React.Fragment>
                    <ListItemButton {...bindTrigger(popupState)} style={{display: 'flex', justifyContent: 'space-between'}}>
                      <ListItemIcon color={blue['600']}>{el.Icon}</ListItemIcon>
                      <ListItemText primary={el.title} />
                      <ArrowRight/>
                    </ListItemButton>
                    <Menu {...bindMenu(popupState)} anchorOrigin={{vertical: 'top', horizontal: 'right'}}>
                      {el.children!
                        .filter(
                          (child) =>
                            !child.crmAdminOnly || currentUser?.level === 0
                        )
                        .map((el, i) => (
                        <Link key={"mainMenu" + i} to={el.to!} onClick={onClick}>
                          <ListItemButton>
                            <ListItemIcon>{el.Icon}</ListItemIcon>
                            <ListItemText primary={el.title} />
                          </ListItemButton>
                        </Link>
                      ))}
                    </Menu>
                  </React.Fragment>
                )}
              </PopupState>
            )
          } else {
            return (
              <Link key={"mainMenu" + i} to={el.to!} onClick={onClick}>
                <ListItemButton>
                  <ListItemIcon>{el.Icon}</ListItemIcon>
                  <ListItemText primary={el.title} />
                </ListItemButton>
              </Link>
            )

          }
      })}
    </React.Fragment>
  )
}
